<!--
  DASHBOARD
   - VLAN 선택 팝업

  @since: 2020-11-10
  @author: tams_dev2
-->
<template>
  <layout-popup :ha-force="true"
                ref="layoutPopUp"
                :titleName="titleName"
                :cancelEvt=onCancel
                :confirmEvt=onConfirm
                @show=onShow
                @hide=onHide
                :footerBtn="footerBtn"
                :content-css="{minWidth: minWidth, minHeight: minHeight}"
                class="bs bs-q-modal bs-q-modal-flat"
  >
    <div class="content-group">
      <div class="contents-row">
        <table class="bs-table table-bordered-none">
          <colgroup>
            <col width="30%"/>
            <col width="auto"/>
          </colgroup>
          <tbody>
            <tr>
              <td class="td-head">{{ $t('lr.filterDateDialog_popup_inputVlanID') }}<span class="textR">*</span></td>
              <td>
                <div class="inline-group">
                  <!-- TAMS -->
                  <q-radio v-model="isTotal" :val="true" color="primary" label="TOTAL"
                           class="bs bs-q-radio bs-q-radio-default" >
                  </q-radio>
                  <q-radio v-model="isTotal" :val="false" color="primary" label=""
                           class="bs bs-q-radio bs-q-radio-default" >
                  </q-radio>
                  <touch-spin v-model="targetVlanId"
                              :disable="isTotal"
                              class="bs bs-q-input bs-q-input-default"
                              :min-value="1"
                              :max-value="4094"
                              name="vlan_num"
                              :error="errors.has('vlan_num')"
                              v-validate="'required'"
                              :ha-force="true">
                  </touch-spin>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </layout-popup>
</template>

<script>
  import LayoutPopup from '~/components/popUp/LayoutModalPopUp'
  import TouchSpin from '~/components/control/touchSpin/TouchSpin'

  export default {
    name: 'vlanSelectPopup',
    props: {
      id: {
        type: Number,
        default: -1
      }
    },
    components: {
      LayoutPopup,
      TouchSpin
    },
    directives: {},
    mixins: [],
    data () {
      return {
        minWidth: '400px', // '290px',
        minHeight: '163px', // '213px',
        isTotal: true,
        targetVlanId: 1,
        footerBtn: ['cancel', 'confirm'],
        titleName: this.$t('po.qosProfileSettings_profile_vlan_name')
      }
    },
    computed: {},
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      this.isTotal = (this.id === -1)
      this.targetVlanId = this.isTotal ? 1 : _.cloneDeep(this.id)
      this.$refs.layoutPopUp.show()
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    destroyed () {},
    errorCaptured () {},
    methods: {
      onShow () {},
      onHide () {
        this.$refs.layoutPopUp.hide()
      },
      onCancel () {
        this.onHide()
      },
      async onConfirm () {
        this.onHide()
        await this.$emit('confirm', {'vlanId': this.isTotal ? -1 : this.targetVlanId})
      },
      clear () {}
    }
  }
</script>

<style scoped>

</style>
